<div class="modal-card">
    
    <div class="modal-header">
        <div class="title-wrapper">
            <h2>Unenroll</h2>
        </div>
        <button class="close-icon" (click)="onCancel()" aria-label="Close">
            &#10005; </button>
    </div>

    <div class="modal-body">
        <p>If you no longer wish to participate in the UPS® Rewards Program, you may unenroll (i.e., terminate your participation in the UPS Rewards Program) at any time by logging into your account at <a href="https://rewards.ups.com" target="_blank">rewards.ups.com</a> and selecting the “Unenroll” option. Terms used below have the meaning assigned to them in the UPS® Rewards Program Terms and Conditions (“Terms”).</p>
        
        <p>Please note the following important conditions:</p>
        
        <ul>
            <li>Account Deletion Is Permanent: Once you unenroll, your Rewards Account will be permanently deleted. This action cannot be reversed.</li>
            <li>Forfeiture of Points and Offers: All unused Points, rewards, and promotional offers associated with your Rewards Account will be forfeited upon unenrollment.</li>
            <li>Re-enrollment: If you choose to rejoin the program in the future, you will need to complete a new enrollment and accept the then-current Terms. Any previously earned Points or offers will not be reinstated.</li>
        </ul>

        <p>For complete term regarding the Program, including without limitation terms related to termination of your participation in the Program, visit <a href="https://rewards.ups.com" target="_blank">rewards.ups.com</a>.</p>
        
        <p>For questions or assistance, please contact UPS Rewards Customer Support at <a href="mailto:UPSRewards&#64;UPS.com">UPSRewards&#64;UPS.com</a>.</p>
        
        <div class="checkbox-container">
            <label class="custom-checkbox">
                <input type="checkbox" [checked]="isAgreed" (change)="toggleAgreement($event)">
                <span class="checkmark"></span>
                <span class="label-text">By continuing, I agree to Terms and Conditions</span>
            </label>
        </div>
    </div>

    <div class="modal-footer">
    <button class="btn-unenroll" 
            [disabled]="!isAgreed || isLoading" 
            [class.disabled]="!isAgreed || isLoading" 
            (click)="onConfirm()">
        {{ isLoading ? 'Processing...' : 'Unenroll' }} 
        <span class="arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M0.286644 11.7148C0.095548 11.5247 0 11.2955 0 11.0273C0 10.7592 0.095548 10.5213 0.286644 10.3137L4.60567 6.00649L0.260416 1.69988C0.0868051 1.50933 0 1.27146 0 0.986265C0 0.700652 0.095548 0.471498 0.286644 0.298802C0.49481 0.0912341 0.728997 -0.00819075 0.989205 0.000527086C1.24941 0.00882978 1.47486 0.108255 1.66554 0.298802L6.71336 5.3321C6.81744 5.43589 6.89134 5.54403 6.93505 5.65653C6.97835 5.76903 7 5.88569 7 6.00649C7 6.14515 6.97835 6.27052 6.93505 6.3826C6.89134 6.4951 6.81744 6.60325 6.71336 6.70703L1.69177 11.7148C1.4836 11.9049 1.24941 12 0.989205 12C0.728997 12 0.49481 11.9049 0.286644 11.7148Z" 
                      fill="currentColor"/>
            </svg>
        </span>
    </button>

    <button class="btn-stay" [disabled]="isLoading" (click)="onCancel()">
        Stay Enrolled 
        <span class="arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M0.286644 11.7148C0.095548 11.5247 0 11.2955 0 11.0273C0 10.7592 0.095548 10.5213 0.286644 10.3137L4.60567 6.00649L0.260416 1.69988C0.0868051 1.50933 0 1.27146 0 0.986265C0 0.700652 0.095548 0.471498 0.286644 0.298802C0.49481 0.0912341 0.728997 -0.00819075 0.989205 0.000527086C1.24941 0.00882978 1.47486 0.108255 1.66554 0.298802L6.71336 5.3321C6.81744 5.43589 6.89134 5.54403 6.93505 5.65653C6.97835 5.76903 7 5.88569 7 6.00649C7 6.14515 6.97835 6.27052 6.93505 6.3826C6.89134 6.4951 6.81744 6.60325 6.71336 6.70703L1.69177 11.7148C1.4836 11.9049 1.24941 12 0.989205 12C0.728997 12 0.49481 11.9049 0.286644 11.7148Z" 
                      fill="currentColor"/>
            </svg>
        </span>
    </button>
</div>


</div>